module.exports = __webpack_public_path__ + "25c9f9571d92b7879b4c234b4997bccf.svg";